import React from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

interface PhoneNumberInputProps {
  name: string;
  value: string;
  countryCode?: string;
  placeholder?: string;
  hasError?: boolean;
  onChange: (name: string, value: string, countryCode: string) => void;
}

const PhoneNumberInput: React.FC<PhoneNumberInputProps> = ({
  name,
  value,
  countryCode = "+91",
  placeholder,
  hasError,
  onChange,
}) => {
  const dialCode = countryCode.replace(/\D/g, "") || "91";
  const localNumber = String(value || "").replace(/\D/g, "");
  const phoneValue = `${dialCode}${localNumber}`;

  return (
    <PhoneInput
      country="in"
      value={phoneValue}
      onChange={(phone, country: any) => {
        const selectedDialCode = String(country?.dialCode || dialCode);
        const selectedCountryCode = `+${selectedDialCode}`;
        const selectedLocalNumber = String(phone || "")
          .replace(/\D/g, "")
          .replace(new RegExp(`^${selectedDialCode}`), "");

        onChange(name, selectedLocalNumber, selectedCountryCode);
      }}
      enableSearch
      inputProps={{
        name,
        autoComplete: "tel",
      }}
      placeholder={placeholder}
      containerClass="phone-input-container"
      inputClass={`form-control custom-input phone-input-field ${
        hasError ? "is-invalid" : ""
      }`}
      buttonClass="phone-input-button"
      dropdownClass="phone-input-dropdown"
      searchClass="phone-input-search"
    />
  );
};

export default PhoneNumberInput;
